import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type ApiError = {
  message: string;
  source?: string;
};

type ApiErrorState = {
  error: ApiError | null;
};

const initialState: ApiErrorState = {
  error: null,
};

const apiErrorSlice = createSlice({
  name: 'apiError',
  initialState,
  reducers: {
    setApiError: (state, action: PayloadAction<ApiError>) => {
      state.error = action.payload;
    },
    clearApiError: state => {
      state.error = null;
    },
  },
});

export const { setApiError, clearApiError } = apiErrorSlice.actions;
export default apiErrorSlice.reducer;
